<template>
    <div class="wrapper">
        <div class="item">

            <div class="image">
                <images :imagedata="itemdata" :fieldname="'field_reperto_foto'"
                    :breakstyles="{'0': 'sm_image', '576': 'md_image'}"></images>
            </div>

            <router-link class="title-container" :to="this.ctTitle" @click.native="selectReperto(itemdata.attributes.drupal_internal__nid)">
                <h3 class="time">{{ itemdata.attributes.field_reperto_periodo }}</h3>
                <p class="title">{{ itemdata.attributes.title }}</p>
            </router-link>

            <div class="cta">
                <p>
                    <span v-if="itemdata.attributes.field_ordine_esposizione <= 9">0</span>{{itemdata.attributes.field_ordine_esposizione}}
                </p>
                <img src="@/assets/icon-arrow-w.svg" alt="">
            </div>

        </div>
    </div>
</template>

<script>
    import Images from '@/components/Images'

    export default {
        name: "item-tile",
        data: () => {
            return {}
        },
        components: {
            Images
        },
        props: {
            routesdata: Array,
            itemdata: Object
        },
        computed: {
            ctTitle() {
                var t = (this.lang == this.defaultLang ? '' : ('/' + this.lang)) + "/not-found"
                this.routesdata.forEach(f => {
                    if (f.lang == this.lang && parseInt(f.nid) == this.itemdata.attributes
                        .drupal_internal__nid) {
                        t = f.path
                    }
                })
                return t
            },
            lang() {
                return this.$store.state.currentLang
            }
        },
        methods: {
            selectReperto(id) {
                this.$store.commit('SET_SELECTED_REPERTO', id)
                console.log('go to', this.ctTitle)
            },
            goToCT() {
                this.$router.push(
                    this.ctTitle
                )
            }
        },
        mounted() {
      
        },
        watch: {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/variables.scss";

    .cta {
        background-color: #C79641;
        position: absolute;
        right: 0;
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        color: #fff;

        p {
            margin: 0;
            font-size: 20px;
            color: #fff;
            margin-bottom: 5px;
        }
    }

    .title-container {
        z-index: 3;
        position: relative;
        padding-right: 50px;
        text-decoration: none;
    }

    .wrapper .item {
        padding:  30px 20px ;
        position: relative;

        display: flex;
        border-bottom: 1px solid #445068;

        .to-detail {
            right: 0;
            background-color: transparent;
            border-radius: 50%;
            transition: transform, background-color 300ms ease;
        }


        .image {
            display: flex;
            justify-content: center;
            position: relative;
            width: 70px;
            height:  70px;
                min-width: 70px;
        min-height: 70px;
        max-width: 70px;
        max-height: 70px;
            margin-right: 1rem;

            ::v-deep picture>img,
            img {
                width: 100%;
                height: 100%;
                position: relative;
                z-index: 1;
                object-fit: contain;
            }

            ::v-deep picture {
                width: 100%;
            }
        }

        .title {
            position: relative;
            z-index: 4;
            transition: all 300ms ease;
            color: #fff;
            font-size: 1rem;
            line-height: 24px;
            margin-bottom: 0;
            margin-top: 6px;
        }

        .time {
            color: #5F8669;
            margin-top: 0;
            margin-bottom: 0px;
            font-size: 0.875rem;
            text-transform: none;
            position: relative;
            font-family: "Martel";
            z-index: 4;
        }
    }

    //.wrapper:hover {
    .title-container:hover {
        cursor: pointer;
        display: block;
        //.item {
            .to-detail {
                transform: scale(1.2);
                transition: 0.2s;
                background-color: rgba(#fff, .3);
            }

            .title {
                color: $primaryColor;
                transition: all 300ms ease;
            }
        //}
    }

 

</style>